import Vue from 'vue'
import popupConfirm from './Popconfirm.vue'

export default {
  // 注意点: 如果要将一个组件封装成一个插件, 那么必须提供一个install方法
  //         那么必须在install方法中注册当前的这个组件
  install: function (Vue, router) {
    Vue.component('popupConfirm', popupConfirm)

    // 1.根据我们的组件生成一个构造函数
    let ConfirmContructor = Vue.extend(popupConfirm)
    // 2.根据构造函数创建实例对象
    let ConfirmInstance = new ConfirmContructor()
    // 3.随便创建一个标签(元素)
    let oDiv = document.createElement('div')
    // 4.将创建好的标签添加到界面上
    document.body.appendChild(oDiv)
    // 5.将创建好的实例对象挂载到创建好的元素上
    ConfirmInstance.$mount(oDiv)

    // 添加全局方法
    Vue.showConfirm = function () {
      ConfirmInstance.dialogVisible = true
    }
    Vue.hiddenConfirm = function () {
      ConfirmInstance.dialogVisible = false
    }
    // 添加实例方法
    Vue.prototype.$showConfirm = function () {
      ConfirmInstance.isShow = true
    }
    Vue.prototype.$hiddenConfirm = function () {
      ConfirmInstance.isShow = false
    }
    Vue.prototype.goToInfo = function (path) {
      router.push(path)
    }
  }
}
